import type { MultiSelectStaticDimensionProps } from "../../components/dimensions/MultiSelectStaticDimension";
import { DimensionTypes } from "../../types/dimensions";

import type { DimensionFixtureExample } from ".";

export const BaseMultiSelectStaticDimensionProps: MultiSelectStaticDimensionProps =
    {
        id: "multi_select_static",
        type: DimensionTypes.MULTI_SELECT_STATIC,
        dependencies: [],
        optional: false,
        configuration: {
            label: "Level 1",
            items: [
                {
                    value: "A",
                    label: "Category A",
                    subText: "First level category",
                },
                {
                    value: "K",
                    label: "Category K",
                    subText: "First level category",
                },
                {
                    value: "Z",
                    label: "Category Z",
                    subText: "First level category",
                },
                {
                    value: "O",
                    label: "Category O",
                    subText: "No subitem first level category",
                },
            ],
            enableBulkActions: true,
            delimiter: ",",
        },
    };

export const MultiSelectStaticDimensionExamples: Record<
    string,
    DimensionFixtureExample
> = {
    base: {
        id: "multiselect_static_base",
        name: "Multi-Select Static Dimension Base",
        description: "only works with mock server",
        dimensions: [[BaseMultiSelectStaticDimensionProps]],
    },
    withMaxItems: {
        id: "multiselect_static_max",
        name: "Multi-Select Static with Max Items",
        description:
            "only works with mock server. with maximum selection limit",
        dimensions: [
            [
                {
                    ...BaseMultiSelectStaticDimensionProps,
                    id: "multi_select_static_max",
                    configuration: {
                        ...BaseMultiSelectStaticDimensionProps.configuration,
                        label: "Select up to 2 categories",
                        maxItemsSelected: 2,
                    },
                },
            ],
        ],
    },
    dependency: {
        id: "multiselect_static_dependency",
        name: "Multi-Select Static with dependency",
        description: "only works with mock server. with dependency filter",
        dimensions: [
            [
                BaseMultiSelectStaticDimensionProps,
                {
                    id: "second_level",
                    type: DimensionTypes.MULTI_SELECT_STATIC,
                    dependencies: ["multi_select_static"],
                    optional: false,
                    configuration: {
                        label: "Level 2",
                        items: [
                            {
                                value: "AB",
                                label: "Subcategory AB",
                                subText: "Child of A",
                            },
                            {
                                value: "AX",
                                label: "Subcategory AX",
                                subText: "Child of A",
                            },
                            {
                                value: "KM",
                                label: "Subcategory KM",
                                subText: "Child of K",
                            },
                            {
                                value: "KN",
                                label: "Subcategory KN",
                                subText: "Child of K",
                            },
                            {
                                value: "ZY",
                                label: "Subcategory ZY",
                                subText: "Child of Z",
                            },
                        ],
                        enableBulkActions: true,
                        delimiter: ",",
                    },
                },
                {
                    id: "third_level",
                    type: DimensionTypes.MULTI_SELECT_STATIC,
                    dependencies: ["multi_select_static", "second_level"],
                    optional: false,
                    configuration: {
                        label: "Level 3",
                        items: [
                            {
                                value: "ABC",
                                label: "Item ABC",
                                subText: "Child of AB",
                            },
                            {
                                value: "ABD",
                                label: "Item ABD",
                                subText: "Child of AB",
                            },
                            {
                                value: "AXP",
                                label: "Item AXP",
                                subText: "Child of AX",
                            },
                            {
                                value: "KMQ",
                                label: "Item KMQ",
                                subText: "Child of KM",
                            },
                            {
                                value: "KNR",
                                label: "Item KNR",
                                subText: "Child of KN",
                            },
                            {
                                value: "ZYS",
                                label: "Item ZYS",
                                subText: "Child of ZY",
                            },
                        ],
                        enableBulkActions: true,
                        delimiter: ",",
                    },
                },
            ],
        ],
    },
};
